import { render, staticRenderFns } from "./DownloadFile.vue?vue&type=template&id=12866218&scoped=true&"
import script from "./DownloadFile.vue?vue&type=script&lang=js&"
export * from "./DownloadFile.vue?vue&type=script&lang=js&"
import style0 from "./DownloadFile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DownloadFile.vue?vue&type=style&index=1&id=12866218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12866218",
  null
  
)

export default component.exports